import moment, { Moment } from "moment-timezone";
import { ClasseAtivo } from "../enum";

interface IPosicaoAtivo {
  codigoAtivo: string;
  classeAtivo: ClasseAtivo;
  data: Moment;
  quantidade: number;
  precoMedio: number;
  valorAplicado: number;
}

export default class PosicaoAtivo implements IPosicaoAtivo {
  public codigoAtivo!: string;
  public classeAtivo!: ClasseAtivo;
  public data!: Moment;
  public quantidade!: number;
  public precoMedio!: number;
  public valorAplicado!: number;

  constructor(param: IPosicaoAtivo) {
    Object.assign(this, param);
  }

  public static fromJson(json: IPosicaoAtivoJson) {
    return new PosicaoAtivo({
      ...json,
      data: moment.tz(json.data, "America/Sao_Paulo"),
    });
  }
}

export interface IPosicaoAtivoJson extends Omit<IPosicaoAtivo, "data"> {
  data: string;
}
